import { GraduationCap } from "lucide-react";
import Reveal from "@/components/ui/Reveal";
import { EmptyState } from "@/components/ui/States";
import { EDUCATION } from "@/data/portfolio";

export default function EducationWindow() {
  return (
    <div className="space-y-5 p-6 sm:p-7" data-testid="education-content">
      <p className="eyebrow">ls education/ — chronological</p>

      <div className="space-y-4">
        {EDUCATION.map((e, i) => (
          <Reveal key={e.degree} delay={i * 0.08}>
            <article className="flex gap-4 rounded-xl border border-white/8 bg-white/[.03] p-5 transition-colors duration-200 hover:bg-white/[.05]" data-testid={`education-card-${i}`}>
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-sonoma/15 ring-1 ring-sonoma/25">
                <GraduationCap size={18} className="text-sky-300" />
              </span>
              <div className="min-w-0">
                <div className="flex flex-wrap items-baseline justify-between gap-2">
                  <h3 className="font-display text-base font-bold text-white">{e.degree}</h3>
                  <span className="font-mono text-[11px] text-sky-300">{e.period}</span>
                </div>
                <p className="mt-1 text-[13px] text-slate-300">{e.institution}</p>
                <p className="font-mono text-[11px] text-slate-500">{e.location}</p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>

      <p className="font-mono text-[11px] text-slate-500">
        $ certifications --list <span className="text-slate-600"># none on record — everything certified the hard way: production</span>
      </p>
    </div>
  );
}
